import { BACKGROUND_IMAGE_MOBILE, BACKGROUND_IMAGE_DESKTOP } from '../elements/assets'

export const CONTENT_INTRO = `
...on contentIntro_Entry {
  id
  typeHandle
  anchorId
  
  backgroundColor
  ${ BACKGROUND_IMAGE_MOBILE }
  ${ BACKGROUND_IMAGE_DESKTOP }
  headingAdvanced {
    html
  }
  description
}
`